module.exports = __webpack_public_path__ + "static/assets/af8baf5169aaa1049aed519f06ba3c56.svg";